module.exports = __webpack_public_path__ + "img/DelightfulTreats.e76620cb.png";